import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { PlatformService } from '@panamax/app-state';

@Component({
  selector: 'app-selection-banner',
  templateUrl: './selection-banner.component.html',
  styleUrls: ['./selection-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectionBannerComponent {
  @Input() isMakePaymentFlow = false;
  @Input() isDownloadEnabled = true;
  @Input() showMainAction = false;
  @Input() countItemsSelected = 0;
  @Input() warningMessage = '';
  @Input() labelMainActionBtn = '';
  @Input() totalPaymentAmount: number = null;

  @Output() selectAllClickEmitter: EventEmitter<any> = new EventEmitter();
  @Output() deselectAllClickEmitter: EventEmitter<any> = new EventEmitter();
  @Output() downloadClickEmitter: EventEmitter<any> = new EventEmitter();
  @Output() mainActionClickEmitter: EventEmitter<any> = new EventEmitter();

  constructor(public platformService: PlatformService) {}

  onSelectAllClick() {
    this.selectAllClickEmitter.emit();
  }

  onDeselectAllClick() {
    this.deselectAllClickEmitter.emit();
  }

  onDownloadClick() {
    this.downloadClickEmitter.emit();
  }

  onMainActionClick() {
    this.mainActionClickEmitter.emit();
  }
}
